module.exports = __webpack_public_path__ + "static/media/question_icon-dark_bg.6e317145.svg";


//////////////////
// WEBPACK FOOTER
// ./src/playground/components/toggle/img/question_icon-dark_bg.svg
// module id = 404
// module chunks = 0